import { HotelRatings } from "@website/accommodation-ui/constant/schema";
import {
  RatingColor,
  TourCardRatingProperties
} from "@website/accommodation-ui/tour-card/tour-card-hotel-rating/types";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import clamp from "lodash-es/clamp";

const isNewLimit = 5;

const getTextAndColorFromHotelRating = (
  rating: number,
  reviewCount: number
) => {
  const clampedRate = clamp(rating, 0, 5);
  const shouldRender = clampedRate > 0;
  if (isFilled(reviewCount) && reviewCount < isNewLimit) {
    return {
      clampedRate,
      text: "جدید",
      color: "secondary",
      shouldRender
    } as const;
  }
  const ratingItem =
    HotelRatings.filter((item) => clampedRate >= item.minRate).pop() ||
    HotelRatings[0];

  const text = `${numberConvert(clampedRate, { locale: "fa" })} ${
    ratingItem.text
  }`;

  return {
    clampedRate,
    text,
    color: ratingItem.color as RatingColor,
    shouldRender
  };
};

export const useTourCardRating = (properties: TourCardRatingProperties) => {
  const { rating, reviewCount } = properties;
  const {
    shouldRender,
    color: badgeColor,
    text: badgeText
  } = getTextAndColorFromHotelRating(rating as number, reviewCount as number);

  return {
    shouldRender,
    badgeColor,
    badgeText
  };
};
